import { underwritingSettingsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SETTINGS_ACTION_TYPE = createNamedActions('underwritingSettings', {
  GET_SETTINGS: 'GET_SETTINGS',
  EDIT_SETTING: 'EDIT_SETTING',
});

const settingsSchema = new schema.Entity('data', {}, { idAttribute: 'name' });

export const getUnderwritingSettingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwritingSettingsApi.getUnderwritingSettings(params);

  dispatch({
    type: SETTINGS_ACTION_TYPE.GET_SETTINGS,
    payload: normalize(data, [settingsSchema]).entities.data,
  });
});

export const editUnderwritingSettingAction = catchAsyncActionError(
  ({ settingName, value }) =>
    async dispatch => {
      await underwritingSettingsApi.editUnderwritingSettings({ settingName, value });

      return dispatch({
        type: SETTINGS_ACTION_TYPE.EDIT_SETTING,
        payload: {
          name: settingName,
          value,
        },
      });
    },
);
